import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" header ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" go bar ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" footer ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_header = _resolveComponent("ag-header")!
  const _component_ag_button = _resolveComponent("ag-button")!
  const _component_ag_box = _resolveComponent("ag-box")!
  const _component_ag_content = _resolveComponent("ag-content")!
  const _component_ag_footer = _resolveComponent("ag-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ag_header, null, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_ag_content, null, {
      default: _withCtx(() => [
        _createVNode(_component_ag_button, { onClick: _ctx.goBar }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["onClick"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
          return (_openBlock(), _createBlock(_component_ag_box, { key: item }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item), 1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_ag_footer, null, {
      default: _withCtx(() => [
        _hoisted_3
      ]),
      _: 1
    })
  ], 64))
}